exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-links-ig-tsx": () => import("./../../../src/pages/links/ig.tsx" /* webpackChunkName: "component---src-pages-links-ig-tsx" */),
  "component---src-pages-links-tw-tsx": () => import("./../../../src/pages/links/tw.tsx" /* webpackChunkName: "component---src-pages-links-tw-tsx" */)
}

